import React from 'react'
import AttractionList from './AttractionList'
import AttractionSelector from './AttractionSelector'

class ManageAttractions extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      array: [],
      filter: props.filter,
      functionState: ''
    }
  }

  componentDidMount = () => {
    let data = {
      id: this.props.id,
      filter: this.state.filter
    }
    this.props.getItem(data)
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter }
    filter.item_page = page
    this.setState({ filter })
    const data = {
      id: this.props.id,
      filter: filter
    }
    this.props.getItem(data)
  }

  _arrayAdd = (id, title, is_disabled) => {
    let array = this.state.array
    array.push({ id, title, is_disabled })
    this.setState({ array })
  }

  _arrayDecrease = (id) => {
    let array = this.state.array
    let targetIndex = array.map(function (item) { return item.id }).indexOf(id)
    array.splice(targetIndex, 1)
    this.setState({ array })
  }

  _functionStateChange = (event) => {
    if (event) event.preventDefault()
    let value = event.target.value
    this.setState({ functionState: value })
  }

  _executeToggle = (method) => {
    let converter = this.state.array.map((item) => item.id)
    let data = { attraction_ids: converter }
    if (method === 'enable') {
      this.props.enable(data)
    } else if (method === 'disable') {
      this.props.disable(data)
    }
    this._forceReload()
  }

  _forceReload = () => {
    let data = {
      id: this.props.id,
      filter: this.state.filter
    }
    setTimeout(() => {
      this.setState({ array: [], functionState: '' })
      setTimeout(() => {
        this.props.getItem(data)
      }, 300)
    }, 300)
  }

  _changePage = (page) => {
    let filter = { ...this.state.filter }
    filter.item_page = page
    this.setState({ page, filter })
    const data = {
      id: this.props.id,
      filter: filter
    }
    this.props.getItem(data)
  }

  render () {
    const { cronReport } = this.props
    const { data_item } = cronReport
    const { data, meta } = data_item
    return (
      <section className='section' style={{ width: '70vw' }}>
        <header className='title-block'>
          <h1 className='title'>Enable / Disable Whitelisted Attraction</h1>
        </header>
        <AttractionList
          data={data}
          meta={meta}
          arrayAdd={(id, title, is_disabled) => this._arrayAdd(id, title, is_disabled)}
          changePage={this._changePage}
        />
        <AttractionSelector
          array={this.state.array}
          functionState={this.state.functionState}
          arrayDecrease={(id) => this._arrayDecrease(id)}
          functionStateChange={(event) => this._functionStateChange(event)}
          executeToggle={(functionState) => this._executeToggle(functionState)}
          closeModal={() => this.props.closeModal()}
        />
      </section>
    )
  }
}

export default ManageAttractions



// WEBPACK FOOTER //
// ./src/Containers/CronReport/ManageAttractions.js